import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { UserFlagsEffects } from './store/effects/user-flags.effects';
import { userFlagsReducer } from './store/reducers/user-flags.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('userFlags', userFlagsReducer),
    EffectsModule.forFeature([UserFlagsEffects]),
  ],
})
export class UserFlagsModule {}
